import { axiosGetSSO, axiosPost, axiosPostAuthorize, axiosPostSSO } from '../AxiosRequests';
import { AdminLogin, GetUserDetailsByClientIdAndSecretkey, Login, ProjectAuthentication, ResetPassword, ValidateToken } from '../ApiEndPoints';

export default class AccountServices {

    //** Call login API */
    async adminLogin(request) {
        return axiosPostSSO(AdminLogin, request);
    }

    async resetPassword(request) {
        return axiosPostAuthorize(ResetPassword, request);
    }

    async validateToken(request) {
        return axiosPostSSO(ValidateToken, request);
    }

    async projectAuthentication(request) {
        return axiosPost(ProjectAuthentication, request);
    }

    async getUserDetailsByClientIdAndSecretkey(request) {
        return axiosGetSSO(GetUserDetailsByClientIdAndSecretkey, request);
    }
}